export const MusicOffSVG = (props) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="primary"
      d="M17,5.15a23.88,23.88,0,0,1-3.27-2.84,1,1,0,0,0-1.09-.24A1,1,0,0,0,12,3V13.76a4.5,4.5,0,1,0,2,3.74V5.34a15.88,15.88,0,0,0,1.9,1.49c.83.54,1.57,1.41.74,3.85a1,1,0,0,0,1.9.64C19.49,8.5,19,6.43,17,5.15Z"
      fill="#dcdfe1"
    />
    <path
      id="secondary"
      d="M19,22a1,1,0,0,1-.79-.39l-14-18A1,1,0,0,1,5.79,2.39l14,18a1,1,0,0,1-.18,1.4A1,1,0,0,1,19,22Z"
      fill="#dcdfe1"
    ></path>
  </svg>
)
